import {useNavigate} from "react-router-dom";
import {StringUtil} from "../../../util/StringUtil.ts";
import {useEffect, useState} from "react";
import {TimeUtil} from "../../../util/TimeUtil.ts";

export type ClickableActionRendererProps = {
    title: string
    data: any,
    value: string
    onClick?: (data: any) => void
    path?: string
    isCurrency?: boolean
    isDate?: boolean
}

export function BaseActionRenderer(baseActionRendererProps: ClickableActionRendererProps) {
    const navigate = useNavigate();
    const greenBadgeText = ["active", "approved", "paid"]
    const redBadgeText = ["inactive", "rejected", "closed", "failed", "reversed"]
    const yellowBadgeText = ["pending", "submitted"]

    const [value, setValue] = useState(baseActionRendererProps?.isCurrency ? StringUtil.handleCurrencyFormatter(baseActionRendererProps?.value || "") : baseActionRendererProps?.value)

    const renderFormattedValue = (baseActionRendererProps: ClickableActionRendererProps) => {
        if (baseActionRendererProps?.isCurrency) {
            return StringUtil.handleCurrencyFormatter(baseActionRendererProps?.value || "");
        }
        if (!TimeUtil.isValidDate(baseActionRendererProps.value)) {
            return StringUtil.convertToSentenceCase(baseActionRendererProps?.value)
        } else {
            return TimeUtil.formatDateString(baseActionRendererProps?.value)
        }
    }

    useEffect(() => {
        setValue(renderFormattedValue(baseActionRendererProps))
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "flex-start",
                // backgroundColor: "white",

            }}
            onClick={() => {
                baseActionRendererProps?.onClick && baseActionRendererProps?.onClick({...baseActionRendererProps.data})
                baseActionRendererProps?.path && (
                    navigate(baseActionRendererProps?.path, {
                        state: {
                            ...baseActionRendererProps.data,
                        }
                    })
                )
            }}
        >
            <div
                className={
                    `${greenBadgeText.includes(baseActionRendererProps?.value?.toString().toLowerCase()) ? "badge-active" : ""}
                     ${redBadgeText.includes(baseActionRendererProps?.value?.toString().toLowerCase()) ? "badge-inactive" : ""}
                     ${yellowBadgeText.includes(baseActionRendererProps?.value?.toString().toLowerCase()) ? "badge-pending" : ""}`
                }
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // // padding: 2
                }}
            >
                {
                    (baseActionRendererProps?.onClick || baseActionRendererProps?.path) ?
                        <a className="table1_link">{value}</a>
                        :
                        <div>
                            {value}
                        </div>
                }
            </div>
        </div>
    );
}

